import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  products: [],
  filtered: [],
  category: 'All',
  searchTerm: '',
  visibleCount: 20,
  hasMore: true,
  loading: false,
  scrollLoading: false,
  categories: [],
  isAtStart: true,
  isAtEnd: false,
  showScrollUp: false,
  showScrollDown: false,
};

const productSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    setProducts: (state, action) => {
      state.products = action.payload;
      state.filtered = action.payload.filter((p) => p.category?.name !== 'Cake');
      state.hasMore = state.filtered.length > 20;
    },
    setFiltered: (state, action) => {
      state.filtered = action.payload;
      state.visibleCount = 20;
      state.hasMore = action.payload.length > 20;
    },
    setCategory: (state, action) => {
      state.category = action.payload;
    },
    setSearchTerm: (state, action) => {
      state.searchTerm = action.payload;
    },
    setVisibleCount: (state, action) => {
      state.visibleCount = action.payload;
      state.hasMore = state.filtered.length > action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setScrollLoading: (state, action) => {
      state.scrollLoading = action.payload;
    },
    setCategories: (state, action) => {
      state.categories = action.payload;
    },
    setScrollState: (state, action) => {
      state.isAtStart = action.payload.isAtStart;
      state.isAtEnd = action.payload.isAtEnd;
    },
    setScrollButtons: (state, action) => {
      state.showScrollUp = action.payload.showScrollUp;
      state.showScrollDown = action.payload.showScrollDown;
    },
  },
});

export const {
  setProducts,
  setFiltered,
  setCategory,
  setSearchTerm,
  setVisibleCount,
  setLoading,
  setScrollLoading,
  setCategories,
  setScrollState,
  setScrollButtons,
} = productSlice.actions;

export default productSlice.reducer;